import MultiSelect, { MultiSelectProps, Option } from './MultiSelect';

export default MultiSelect;
export type { MultiSelectProps, Option };
